module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": 1000
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trigger),
      callback: function($$v) {
        _vm.trigger = $$v
      },
      expression: "trigger"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pt-0 pb-0"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("cancel")])], 1)], 1)]), _vm._v(" "), _c('full-calendar', {
    attrs: {
      "events": _vm.events,
      "locale": "en"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-392d31de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/calendarModal.vue
// module id = 1224
// module chunks = 16 17